var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52253 12.4658H3.5965L10.2129 5.84932L9.13897 4.77534L2.52253 11.3918V12.4658ZM13.4924 4.73699L10.2321 1.51507L11.3061 0.441096C11.6002 0.147032 11.9615 0 12.39 0C12.8181 0 13.1791 0.147032 13.4732 0.441096L14.5472 1.51507C14.8412 1.80913 14.9947 2.16405 15.0075 2.57984C15.0202 2.99511 14.8796 3.34977 14.5855 3.64384L13.4924 4.73699ZM12.3801 5.86849L4.24856 14H0.988281V10.7397L9.11979 2.60822L12.3801 5.86849Z",
    fill: "#8A939A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0d06e662084e2135472aac3887e95f6c.svg";
export { ForwardRef as ReactComponent };